import { createSelector } from 'reselect';

import { AppState } from '../../../store';

export const ReviewSelector = (state: AppState) => state.review;

export const ReviewStateSelector = createSelector(ReviewSelector, item => item);

export const dataLoadingSelector = createSelector(ReviewSelector, item => {
  return item.dataLoading
});

export const isErrorSelector = createSelector(ReviewSelector, item => {
  return item.isError
});

export const tentativeInfoSelector = createSelector(ReviewSelector, item => {
  return item.tentativeInfo;
});

export const goSafeSelector = createSelector(ReviewSelector, item => {
  return { ...item.goSafe };
});

export const goSafeSocialSelector = createSelector(ReviewSelector, item => {
  return { ...item.goSafeSocial };
});

export const reviewDataSelector = createSelector(ReviewSelector, item => {
  return item.reviewData
});

export const isPromoAndGoCashBothAllowedSelector = createSelector(ReviewSelector, item => {
  return item.reviewData && item.reviewData.allow_both_promo_and_gocash ? item.reviewData.allow_both_promo_and_gocash : false
});

export const selectedPromoIdSelector = createSelector(ReviewSelector, item => {
  return item.promocode
});

export const goCashSelector = createSelector(ReviewSelector, item => {
  return item.goCashSelected
});

export const goTribeSelector = createSelector(ReviewSelector, item => {
  return item?.showGoTribe || false
});

export const goTribeDetailsSelector = createSelector(ReviewSelector, (item) => {
  return item?.tribeDetails || {}
});
